// Disallow special characters
const addressValidatorRegExp = /^[^!"#%&:;<>=@{}~$*+\\?^|]+$/;

// Validate words that have []: [Lviv]
const addressValidatorRegExpForSquareBrackets = /\[.+]/;

// Validate words that have (): (Lviv)
const addressValidatorRegExpForParentheses = /\(.+\)/;

const validateAddress = (value: string | null | undefined): boolean => {
  if (!value) return false;

  const squareBracketsCondition = value.includes('[') || value.includes(']');
  const parenthesesCondition = value.includes('(') || value.includes(')');

  // Validate special characters: "Lviv !"
  if (!addressValidatorRegExp.test(value)) return false;

  // Validate if word has closed square brackets: "[Lviv]"
  if (squareBracketsCondition && !addressValidatorRegExpForSquareBrackets.test(value)) return false;

  // Validate if word has closed parentheses: "(Lviv)"
  if (parenthesesCondition && !addressValidatorRegExpForParentheses.test(value)) return false;

  return true;
};

export default validateAddress;
